import React from 'react';
import { useSelector } from 'react-redux';
import { getSession } from './redux/selectors';
import { SessionContext } from '@wix/da-react-context/pkg/publicSession';

export interface Props {
  children: React.ReactNode;
}

const SessionProvider: React.FC<Props> = ({ children }) => {
  const session = useSelector(getSession);

  return <SessionContext.Provider value={session}>{children}</SessionContext.Provider>;
};
SessionProvider.displayName = 'SessionProvider';

export default SessionProvider;
